import styled from "styled-components";
import {Field} from "../../../Types";
import {LANG} from "../../CONSTANTS";
import TypeIcon from "../../misc/TypeIcon";
import FieldTypeView from "./FieldTypeView";
import hljs from "highlight.js/lib/core";
import {functions} from "../../../config";
import {ShowFieldsWeightU} from "../../../features/schemaManageSlice";
import FieldMapView from "./FieldMapView";


export default function TableFieldSchema({field, showUndefined, fieldsWeight}: {
    field: Field,
    showUndefined: boolean,
    fieldsWeight: ShowFieldsWeightU
}) {
    return (
        <Container className={showUndefined ? "show-undefined" : ""}>
            <table>
                <tbody>
                {renderRow("key", field.key, showUndefined)}
                {renderRow("title", field.title[LANG], showUndefined)}
                <tr>
                    <td>type <TypeIcon type={field.type}/> :</td>
                    <td className="value">
                        {/*<FieldTypeSelector defaultValue={field.type}/>*/}
                        <FieldTypeView fieldType={field.type}/>
                    </td>
                </tr>
                {renderRow("applyTransform", field.applyTransform, showUndefined)}
                {renderRow("inline", field.inline, showUndefined)}
                {renderRow("detailed", field.detailed, showUndefined)}
                {renderRow("editable", field.editable, showUndefined)}
                {renderRow("nullable", field.nullable, showUndefined)}

                {fieldsWeight === "all" && (field.type === "datetime" || field.type === "date" || field.type === "time") &&
                    renderRow("datetimeFormat", field.datetimeFormat, showUndefined)}


                {fieldsWeight === "all" && renderRow("map", field.map, showUndefined, () =>
                    field.map === undefined ? "undefined" : (
                        <FieldMapView map={field.map}/>
                        // <pre style={{width: '100%', display: "inline-grid"}}><code
                        //     style={{overflow: 'auto', maxWidth: '100%'}}
                        //     dangerouslySetInnerHTML={{__html: hljs.highlight(JSON.stringify(field.map, null, 2), {language: 'json'}).value}}
                        //     className={'language-json hljs'}></code></pre>
                    )
                )}

                {fieldsWeight === "all" && renderRow("updateSingleFieldPath", field.updateSingleFieldPath, showUndefined)}

                {fieldsWeight === "all" && renderRow("getColumnValue", field.getColumnValue, showUndefined, () =>
                    field.getColumnValue === undefined ? "undefined" : (
                        <pre style={{width: '100%', display: "inline-grid"}}><code
                            style={{overflow: 'auto', maxWidth: '100%'}}
                            dangerouslySetInnerHTML={{__html: hljs.highlight(functions[field.getColumnValue].toString(), {language: 'javascript'}).value}}
                            className={'language-javascript hljs'}></code></pre>
                    )
                )}


                {fieldsWeight === "all" && renderRow("inlineEditable", field.inlineEditable, showUndefined)}
                {fieldsWeight === "all" && renderRow("comment", field.comment, showUndefined)}
                {fieldsWeight === "all" && renderRow("required", field.required, showUndefined)}
                {fieldsWeight === "all" && renderRow("defaultVal", field.defaultVal, showUndefined)}

                {fieldsWeight === "all" && field.type === "json" && renderRow("jsonHeight", field.jsonHeight, showUndefined)}
                {fieldsWeight === "all" && field.type === "image" && renderRow("imageMaxHeight", field.imageMaxHeight, showUndefined)}
                {fieldsWeight === "all" && field.type === "image" && renderRow("imageMaxWidth", field.imageMaxWidth, showUndefined)}


                </tbody>
            </table>
            <hr/>
        </Container>
    );
}

export function renderRow(
    label: string,
    value: any,
    showUndefined: boolean,
    customRender?: () => React.ReactNode
) {
    const isUndefined = value === undefined;
    if (isUndefined && !showUndefined) return null;

    return (
        <tr className={isUndefined ? "undefined-row" : ""}>
            <td>{label}:</td>
            <td className={`value ${isUndefined ? "undefined-value" : ""}`}>
                {customRender ? customRender() : String(value)}
            </td>
        </tr>
    );
}


const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    justify-content: center;
    height: 100%;

    background-color: hsl(from var(--table-row-odd-bg-color) h s l / 0.3);
    color: var(--table-row-text-color);
    padding: 0.5rem;

    .undefined-row {
        //display: none;
    }

    .show-undefined .undefined-row {
        display: table-row;
    }

    .undefined-value {
        //color: rgba(255, 255, 0, 0.8);
        color: rgba(255, 255, 0, 0.6);
        font-style: italic;
        //border: 2px solid yellow;
    }

    table {
        //width: 50%;
        //max-width: 600px;
        border-collapse: collapse;
        table-layout: auto; /* Let first column size naturally */
    }

    tr {

    }

    td {
        padding: 0.25rem 0.5rem;
        vertical-align: top;
    }

    td:first-child {
        min-width: 220px;
        white-space: nowrap;
        text-align: right;
        font-weight: bold;
    }

    td.value {
        //color: hotpink;
        width: 100%; /* Take the rest of the space */
    }

    td.undefined-value {
        //box-shadow: inset 0px 0px 4px 4px rgba(255, 223, 0, 0.75);
        //border-bottom: 2px solid yellow;
        //border-inline: 2px solid yellow;
    }

    hr {
        background: red;
        height: 2px;
        width: 100%;
        border: none;
        margin-top: auto;
    }
`;
